import { render, staticRenderFns } from "./FundingNeeds.vue?vue&type=template&id=58d4e664&scoped=true&"
import script from "./FundingNeeds.vue?vue&type=script&lang=js&"
export * from "./FundingNeeds.vue?vue&type=script&lang=js&"
import style0 from "./FundingNeeds.vue?vue&type=style&index=0&id=58d4e664&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d4e664",
  null
  
)

export default component.exports